import { __generator } from "tslib";
import { put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { getTierStreamId } from '../helpers';
export default function () {
    var streamId, isFetching;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                streamId = getTierStreamId();
                return [4 /*yield*/, select(selectors.isFetching, streamId)];
            case 1:
                isFetching = _a.sent();
                if (isFetching) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, put(withOffset.actions.fetch(streamId))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=fetchMoreTiers.js.map